import CustomObject from './CustomObject.js'

export default class Wc extends CustomObject
{
    constructor(modelPath, position, id, rotation) {
        super(modelPath, position, id, rotation);
        this.type = "wc";
        this.collisionAllowed = true;
        this.snappingAllowed = true;
        this.axesMove = [true, false, true]; // x, y
        
    }
 
}